var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isDisabledForNightProducts
    ? _c(
        "div",
        { class: ["autorenewal", { "autorenewal--disabled": _vm.isDisabled }] },
        [
          _vm.isBlocked
            ? _c("ui-alert", {
                attrs: {
                  type: "error",
                  title: _vm.i18n.autorenewalBlocked,
                  "small-description": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "description",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.i18n.autorenewalBlockedDescription) +
                              " "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase",
                              attrs: { href: _vm.purchaseCreditsUrl },
                            },
                            [_vm._v(_vm._s(_vm.i18n.purchaseCredits))]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  484294724
                ),
              })
            : _vm.isActive && _vm.isPostList
            ? _c("ui-alert", {
                attrs: { type: "success", title: _vm.i18n.autorenewalActive },
              })
            : !_vm.isPostList
            ? _c(
                "div",
                { staticClass: "autorenewal__box" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("i", {
                            staticClass: "fa fa-refresh",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.i18n.autorenewal) +
                              "\n                "
                          ),
                          _vm.userWithEnoughCredits
                            ? _c("p", { staticClass: "small m-0" }, [
                                _vm._v(_vm._s(_vm.i18n.autorenewalDescription)),
                              ])
                            : [
                                _c(
                                  "p",
                                  { staticClass: "small m-0 text-error" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.autorenewalBlockedDescription
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.isCheckoutPage
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "small",
                                        attrs: { href: _vm.purchaseCreditsUrl },
                                      },
                                      [_vm._v(_vm._s(_vm.i18n.purchaseCredits))]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("label", { staticClass: "switch switch-left-right" }, [
                        _c("input", {
                          staticClass: "switch-input",
                          attrs: {
                            id: "autorenewal-checkbox",
                            type: "checkbox",
                            disabled: _vm.checkboxIsDisabled,
                          },
                          domProps: { checked: _vm.autorenewalIsActive },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleChange($event.target.checked)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "switch-label",
                          class: { disabled: _vm.checkboxIsDisabled },
                          attrs: {
                            "data-on": _vm.i18n.yes,
                            "data-off": _vm.i18n.no,
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "switch-handle",
                          class: { disabled: _vm.checkboxIsDisabled },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.error
                    ? _c("ui-alert", {
                        staticClass: "mt-3",
                        attrs: {
                          type: "error",
                          dismissible: "",
                          title: _vm.i18n.anErrorOccurred,
                        },
                        on: { close: _vm.clearError },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "promo-banner mt-3" }, [
                    _c("div", { staticClass: "badger-right" }, [
                      _c("span", { staticClass: "badge badge-new" }, [
                        _vm._v(_vm._s(_vm.i18n.new)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "promo-banner-container" }, [
                      _c("h6", [_vm._v(_vm._s(_vm.i18n.freeCoupon))]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleLearnMore.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.i18n.learnMore))]
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }